import { render, staticRenderFns } from "./ComplaintHandle.vue?vue&type=template&id=08eb6f7b&scoped=true&"
import script from "./ComplaintHandle.vue?vue&type=script&lang=js&"
export * from "./ComplaintHandle.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintHandle.vue?vue&type=style&index=0&id=08eb6f7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eb6f7b",
  null
  
)

export default component.exports